import React from 'react'

export default function BetaTag({
  bg = '#f0f0f0',
  color = '#002E70',
  borderColor = '#c0c0c0',
  style,
}) {
  return (
    <span
      style={{
        background: bg,
        border: `1px solid ${borderColor}`,
        color,
        fontSize: 10,
        fontWeight: 900,
        borderRadius: 4,
        padding: '6px 10px',
        lineHeight: 1,
        letterSpacing: 1,
        display: 'inline-flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      BETA
    </span>
  )
}
